import * as process from "process";
import { AxiosResponse } from "axios";
import axios from "utils/axios";
import { PaginatedNotificationsType } from "notifications/types";

const TP_API_BASE: string | undefined = process.env.REACT_APP_TP_BASE_URL?.trimEnd();

/** Получение количества уведомлений на ТП */
export const getNotificationsCount = async () => {
  return axios.GET(TP_API_BASE, "/api/rest/v1/notifications/count/");
};

/** Получение уведомлений в колокольчике на ТП */
export const getNotifications = async ({ params }): Promise<AxiosResponse<PaginatedNotificationsType>> => {
  return axios.GET(TP_API_BASE, "/api/rest/v1/notifications/", params);
};

/** Чтение уведомления в колокольчике на ТП */
export const postNotification = async ({ id }): Promise<AxiosResponse<PaginatedNotificationsType>> => {
  return axios.POST(TP_API_BASE, `/api/rest/v1/notifications/${id}/read/`);
};

/** Удаление уведомления в колокольчике на ТП */
export const deleteNotification = async ({ id }): Promise<AxiosResponse<PaginatedNotificationsType>> => {
  return axios.DELETE(TP_API_BASE, `/api/rest/v1/notifications/${id}/`);
};

/** Восстановление уведомления в колокольчике на ТП */
export const postRestoreNotification = async ({ id }): Promise<AxiosResponse<any>> => {
  return axios.POST(TP_API_BASE, `/api/rest/v1/notifications/${id}/restore/`);
};

/** Массовое чтение уведомлений на ТП */
export const postReadAllNotifications = async ({ params }): Promise<AxiosResponse<PaginatedNotificationsType>> => {
  return axios.POST(TP_API_BASE, `/api/rest/v1/notifications/bulk_read/`, params);
};

/** Массовое удаление уведомлений на ТП */
export const postDeleteAllNotifications = async ({ params }): Promise<AxiosResponse<PaginatedNotificationsType>> => {
  return axios.POST(TP_API_BASE, `/api/rest/v1/notifications/bulk_delete/`, params);
};